var _path;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgCirclePlus = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-5752-315a8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8,8.009,8.009,0,0,1-8,8A8.009,8.009,0,0,1-5752-315Zm1,0a7.008,7.008,0,0,0,7,7,7.008,7.008,0,0,0,7-7,7.008,7.008,0,0,0-7-7A7.008,7.008,0,0,0-5751-315Zm6.5,3.5v-3h-3a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h3v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3h3a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-3v3a.5.5,0,0,1-.5.5A.5.5,0,0,1-5744.5-311.5Z",
    transform: "translate(5752 323)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCirclePlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-plus.86ed5834.svg";
export { ForwardRef as ReactComponent };